import { DialogActions, DialogContent, DialogContentText } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';


function SimpleDialog(props) {
  const { onClose, open, message } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Request Successfull</DialogTitle>
      <DialogContent>
        <Typography variant='subtitle1'>{message}</Typography>
        <Typography variant='subtitle1'>You will get the pdf report from donotreply@camsonline.com. </Typography>
        <Typography variant='subtitle2'>Once you get the report, please come here and contunue step 2.</Typography>
        <Typography variant='caption'>It may take upto 15 minutes to receive the report in email.</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
};

export default function SuccessMessage({ message, open, setOpen }) {

  const handleClose = (value) => {
    setOpen(false);
  };

  return (
    <div>
      <SimpleDialog
        open={open}
        onClose={handleClose}
        message={message}
      />
    </div>
  );
}
